export const ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES: Record<string, Record<string, string[]>> = {
  arsenal: {
    'bukayo-saka': [
      'p223340_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788184.png',
      'p223340_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788277.png',
      'p223340_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788232.png',
      'p223340_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m785696.png',
      'p223340_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m785775.png',
      'p223340_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m785720.png'
    ],
    'declan-rice': [
      'p204480_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788211.png',
      'p204480_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788274.png',
      'p204480_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788222.png',
      'p204480_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m789023.png',
      'p204480_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m789020.png'
    ],
    'gabriel-magalhaes': [
      'p226597_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788179.png',
      'p226597_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788273.png',
      'p226597_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788223.png',
      'p226597_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m785701.png',
      'p226597_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m785783.png',
      'p226597_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m785739.png'
    ],
    'gabriel-martinelli': [
      'p444145_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788208.png',
      'p444145_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788270.png',
      'p444145_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788234.png',
      'p444145_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m785695.png',
      'p444145_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m785786.png',
      'p444145_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m785740.png'
    ],
    'piero-hincapie': [
      'p448104_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m791066.png',
      'p448104_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m791067.png',
      'p448104_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m791070.png',
      'p448104_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m791072.png'
    ],
    'martin-odegaard': [
      'p184029_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788201.png',
      'p184029_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788296.png',
      'p184029_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788230.png',
      'p184029_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m785692.png',
      'p184029_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m785785.png',
      'p184029_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m785715.png'
    ],
    'viktor-gyokeres': [
      'p224117_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788182.png',
      'p224117_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788287.png',
      'p224117_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788229.png',
      'p224117_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m785691.png',
      'p224117_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m785781.png',
      'p224117_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m785741.png'
    ]
  },
  'aston-villa': {
    'emiliano-buendia': [
      'p195546_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m784387.png',
      'p195546_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781095.png',
      'p195546_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781170.png',
      'p195546_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781126.png'
    ],
    'emiliano-martinez': [
      'p98980_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m784401.png',
      'p98980_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m784469.png',
      'p98980_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m784406.png',
      'p98980_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781104.png',
      'p98980_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781182.png',
      'p98980_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781120.png'
    ],
    'john-mcginn': [
      'p122806_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m784392.png',
      'p122806_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m784474.png',
      'p122806_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m784405.png',
      'p122806_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781110.png',
      'p122806_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781183.png',
      'p122806_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781128.png'
    ],
    'ollie-watkins': [
      'p178301_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m784390.png',
      'p178301_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m784460.png',
      'p178301_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m784416.png',
      'p178301_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781098.png',
      'p178301_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781165.png',
      'p178301_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781133.png'
    ],
    'youri-tielemans': [
      'p166989_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m784397.png',
      'p166989_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m784466.png',
      'p166989_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m784413.png',
      'p166989_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781094.png',
      'p166989_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781178.png',
      'p166989_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781130.png'
    ]
  },
  bournemouth: {
    'alex-scott': [
      'p503139_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781225.png',
      'p503139_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781290.png',
      'p503139_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781246.png',
      'p503139_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781886.png',
      'p503139_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781984.png',
      'p503139_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781924.png'
    ],
    evanilson: [
      'p444102_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781223.png',
      'p444102_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781288.png',
      'p444102_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781245.png',
      'p444102_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781881.png',
      'p444102_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781964.png',
      'p444102_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781921.png'
    ],
    'julio-soler': [
      'p575901_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781218.png',
      'p575901_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781310.png',
      'p575901_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781256.png',
      'p575901_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781878.png',
      'p575901_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781976.png',
      'p575901_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781916.png'
    ],
    'justin-kluivert': [
      'p222683_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781233.png',
      'p222683_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781298.png',
      'p222683_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781238.png',
      'p222683_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781876.png',
      'p222683_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781975.png',
      'p222683_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781907.png'
    ],
    'marcos-senesi': [
      'p221466_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781214.png',
      'p221466_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781292.png',
      'p221466_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781254.png',
      'p221466_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781894.png',
      'p221466_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781965.png',
      'p221466_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781928.png'
    ],
    tavernier: [
      'p201658_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781213.png',
      'p201658_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781305.png',
      'p201658_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781248.png',
      'p201658_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781900.png',
      'p201658_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781983.png',
      'p201658_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781919.png'
    ],
    'vitor-rayan': [
      'p499604_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m805319.png',
      'p499604_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m805324.png',
      'p499604_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m805322.png',
      'p499604_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m805321.png'
    ]
  },
  brentford: {
    'fabio-carvalho': [
      'Brentford_-_F_Carvalho.png',
      'p244858_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m780568.png',
      'p244858_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m780627.png',
      'p244858_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m780598.png',
      'p244858_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m780770.png',
      'p244858_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m780779.png'
    ],
    'igor-thiago': [
      'p502500_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m780584.png',
      'p502500_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m780630.png',
      'p502500_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m780604.png',
      'p502500_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m780753.png',
      'p502500_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m780791.png',
      'p502500_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m780718.png'
    ],
    'jordan-henderson': [
      'Brentford_-_Henderson.png',
      'p56979_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m780586.png',
      'p56979_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m780643.png',
      'p56979_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m780597.png',
      'p56979_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m780761.png',
      'p56979_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m780785.png'
    ],
    'kevin-schade': [
      'Brentford_-_Schade.png',
      'p513418_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m780567.png',
      'p513418_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m780616.png',
      'p513418_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m780606.png',
      'p513418_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m780772.png',
      'p513418_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m780775.png'
    ]
  },
  brighton: {
    'diego-gomez': [
      'Brighton_-_Diego_Gómez.png',
      'p514254_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m777796.png',
      'p514254_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m777872.png',
      'p514254_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m777829.png',
      'p514254_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m777627.png',
      'p514254_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m777705.png'
    ],
    'james-milner': [
      'Brighton_-_Milner.png',
      'p15157_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m777768.png',
      'p15157_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m777894.png',
      'p15157_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m777812.png',
      'p15157_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m777615.png',
      'p15157_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m777731.png'
    ],
    'kaoru-mitoma': [
      'Brighton_-_Mitoma.png',
      'p451340_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m777794.png',
      'p451340_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m777864.png',
      'p451340_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m777830.png',
      'p451340_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m777631.png',
      'p451340_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m777719.png'
    ],
    kostoulas: [
      'p647850_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m777778.png',
      'p647850_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m777878.png',
      'p647850_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m777820.png',
      'p647850_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m777613.png',
      'p647850_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m777710.png',
      'p647850_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m777645.png'
    ]
  },
  burnley: {
    'armando-borja': [
      'p440323_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787437.png',
      'p440323_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m787450.png'
    ],
    'jacob-bruun-larsen': [
      'Burnley_-_Bruun_Larsen.png',
      'p179458_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m779023.png',
      'p179458_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m779101.png',
      'p179458_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m779055.png',
      'p179458_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m778873.png',
      'p179458_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m778956.png'
    ],
    'kyle-walker': [
      'Burnley_-_Kyle_Walker.png',
      'p58621_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m779035.png',
      'p58621_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m779126.png',
      'p58621_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m779044.png',
      'p58621_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m778854.png',
      'p58621_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m778949.png'
    ],
    'marcus-edwards': [
      'Burnley_-_Edwards.png',
      'p174592_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m779037.png',
      'p174592_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m779124.png',
      'p174592_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m779048.png',
      'p174592_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m778875.png',
      'p174592_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m778960.png'
    ]
  },
  chelsea: {
    'cole-palmer': [
      'p244851_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787618.png',
      'p244851_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787688.png',
      'p244851_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787637.png',
      'p244851_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m785875.png',
      'p244851_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m785949.png',
      'p244851_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m785922.png'
    ],
    'enzo-fernandez': [
      'p448047_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787609.png',
      'p448047_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787689.png',
      'p448047_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787630.png',
      'p448047_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m785888.png',
      'p448047_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m785973.png',
      'p448047_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m785917.png'
    ],
    estevao: [
      'p624773_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787603.png',
      'p624773_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787683.png',
      'p624773_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787645.png',
      'p624773_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m785878.png',
      'p624773_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m785967.png',
      'p624773_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m785907.png'
    ],
    garnacho: [
      'p493105_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m791022.png',
      'p493105_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m791019.png',
      'p493105_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m791021.png',
      'p493105_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m791025.png',
      'p493105_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m791024.png',
      'p493105_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m791023.png'
    ],
    'joao-pedro': [
      'p475168_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787624.png',
      'p475168_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787687.png',
      'p475168_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787641.png',
      'p475168_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m785883.png',
      'p475168_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m785974.png',
      'p475168_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m785906.png'
    ],
    'moises-caicedo': [
      'p486672_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787612.png',
      'p486672_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787699.png',
      'p486672_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787652.png',
      'p486672_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m785884.png',
      'p486672_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m785963.png',
      'p486672_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m785908.png'
    ]
  },
  'crystal-palace': {
    'daniel-munoz': [
      'p247348_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781355.png',
      'p247348_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781446.png',
      'p247348_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781388.png',
      'p247348_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781993.png',
      'p247348_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m782084.png',
      'p247348_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m782031.png'
    ],
    'ismaila-sarr': [
      'p232185_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781346.png',
      'p232185_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781422.png',
      'p232185_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781376.png',
      'p232185_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m782007.png',
      'p232185_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m782082.png',
      'p232185_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m782028.png'
    ],
    'jean-philippe-mateta': [
      'p231747_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781356.png',
      'p231747_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781445.png',
      'p231747_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781393.png',
      'p231747_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m782019.png',
      'p231747_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m782092.png',
      'p231747_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m782042.png'
    ],
    'jefferson-lerma': [
      'p152551_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781365.png',
      'p152551_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781426.png',
      'p152551_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781379.png',
      'p152551_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m782001.png',
      'p152551_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m782089.png',
      'p152551_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m782039.png'
    ]
  },
  everton: {
    beto: [
      'p486385_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m792019.png',
      'p486385_-_Graphics__Player_Assets__AWAY_Full_Length_All_Originals_m792020.png',
      'p486385_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m792018.png',
      'p486385_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m792017.png',
      'p486385_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m792023.png',
      'p486385_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m792021.png'
    ],
    'carlos-alcaraz': [
      'p502697_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m784021.png',
      'p502697_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m784097.png',
      'p502697_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m784039.png',
      'p502697_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781478.png',
      'p502697_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781566.png',
      'p502697_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781508.png'
    ],
    'iliman-ndiaye': [
      'p440993_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m784020.png',
      'p440993_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m784089.png',
      'p440993_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m784048.png',
      'p440993_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781492.png',
      'p440993_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781559.png',
      'p440993_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781513.png'
    ],
    'jack-grealish': [
      'p114283_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787475.png',
      'p114283_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787478.png',
      'p114283_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787476.png',
      'p114283_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m787479.png',
      'p114283_-_Graphics__Player_Assets__HOME_Full_Length_All_Originals_m787481.png',
      'p114283_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m787482.png',
      'p114283_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m787480.png'
    ],
    'james-tarkowski': [
      'p111234_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m784034.png',
      'p111234_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m784101.png',
      'p111234_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m784047.png',
      'p17761_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m784017.png',
      'p17761_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m784084.png',
      'p17761_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m784046.png',
      'p17761_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781485.png',
      'p17761_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781577.png',
      'p17761_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781504.png'
    ]
  },
  fulham: {
    'adama-traore': [
      'p159533_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m780481.png',
      'p159533_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m780523.png',
      'p159533_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m780436.png',
      'p159533_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m783091.png',
      'p159533_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m783163.png',
      'p159533_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m783103.png'
    ],
    'alex-iwobi': [
      'p153133_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m780469.png',
      'p153133_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m780514.png',
      'p153133_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m780437.png',
      'p153133_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m783082.png',
      'p153133_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m783164.png',
      'p153133_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m783101.png'
    ],
    kevin: ['Graphics__Player_Assets__HOME_Full_Length_All_Originals.png'],
    'raul-gimenez': [
      'p102057_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m780474.png',
      'p102057_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m780510.png',
      'p102057_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m780417.png',
      'p102057_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m783076.png',
      'p102057_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m783167.png',
      'p102057_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m783110.png'
    ],
    'rodrigo-muniz': [
      'p244042_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m780470.png',
      'p244042_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m780512.png',
      'p244042_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m780435.png',
      'p244042_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m783085.png',
      'p244042_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m783152.png',
      'p244042_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m783118.png'
    ]
  },
  leeds: {
    'brenden-aaronson': [
      'Leeds_-_James.png',
      'p427637_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m778707.png',
      'p427637_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m778791.png',
      'p427637_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m778737.png',
      'p427637_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m778563.png',
      'p427637_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m778648.png'
    ],
    buonanotte: [
      'p536916_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m803780.png',
      'p536916_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m803787.png',
      'p536916_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m803788.png',
      'p536916_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m803781.png',
      'p536916_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m803784.png',
      'p536916_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m803779.png'
    ],
    'dominic-calvert-lewin': [
      'p177815_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787458.png',
      'p177815_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787461.png',
      'p177815_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787459.png',
      'p177815_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m787463.png',
      'p177815_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m787466.png',
      'p177815_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m787464.png'
    ],
    'lukas-nmecha': [
      'Leeds_-_L._Nmecha_OK.png',
      'p174594_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m778726.png',
      'p174594_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m778811.png',
      'p174594_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m778758.png',
      'p174594_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m778580.png',
      'p174594_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m778662.png',
      'p221399_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m778809.png'
    ]
  },
  liverpool: {
    'alexis-mac-allister': [
      'Liverpool_-_Mac_Allister.png',
      'p243016_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m783242.png',
      'p243016_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m783317.png',
      'p243016_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m783261.png',
      'p243016_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m779884.png',
      'p243016_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m779957.png'
    ],
    'cody-gakpo': [
      'p243298_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m783230.png',
      'p243298_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m783322.png',
      'p243298_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m783284.png',
      'p243298_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m779885.png',
      'p243298_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m779958.png',
      'p243298_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m779930.png'
    ],
    'dominik-szoboszlai': [
      'Liverpool_-_Szoboszlai.png',
      'p424876_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m783243.png',
      'p424876_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m783313.png',
      'p424876_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m783270.png',
      'p424876_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m779882.png',
      'p424876_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m779973.png'
    ],
    'mohamed-salah': [
      'Liverpool_-_Salah.png',
      'p118748_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m783238.png',
      'p118748_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m783312.png',
      'p118748_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m783274.png',
      'p118748_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m779897.png',
      'p118748_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m779979.png'
    ],
    'virgil-van-dijk': [
      'p97032_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m787511.png',
      'p97032_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m787516.png',
      'p97032_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m787512.png'
    ]
  },
  'manchester-city': {
    'bernardo-silva': [
      'p165809_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788901.png',
      'p165809_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788988.png',
      'p165809_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788928.png',
      'p165809_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m787045.png',
      'p165809_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m787118.png',
      'p165809_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m787066.png'
    ],
    'erling-haaland': [
      'p223094_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788909.png',
      'p223094_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788972.png',
      'p223094_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788932.png',
      'p223094_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m787034.png',
      'p223094_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m787121.png',
      'p223094_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m787070.png'
    ],
    'omar-marmoush': [
      'p438234_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788897.png',
      'p438234_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788967.png',
      'p438234_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788931.png',
      'p438234_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m787032.png',
      'p438234_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m787126.png',
      'p438234_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m787058.png'
    ],
    'phil-foden': [
      'p209244_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788918.png',
      'p209244_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788989.png',
      'p209244_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788919.png',
      'p209244_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m787038.png',
      'p209244_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m787132.png',
      'p209244_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m787069.png'
    ],
    rodri: [
      'p220566_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788906.png',
      'p220566_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788984.png',
      'p220566_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788936.png',
      'p220566_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m787041.png',
      'p220566_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m787139.png',
      'p220566_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m787075.png'
    ]
  },
  'manchester-united': {
    'bruno-fernandes': [
      'p141746_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m790910.png',
      'p141746_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m790977.png',
      'p141746_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m790918.png',
      'p141746_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m786824.png',
      'p141746_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m786938.png',
      'p141746_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m786859.png'
    ],
    'bryan-mbeumo': [
      'p446008_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m790898.png',
      'p446008_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m790987.png',
      'p446008_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m790916.png',
      'p446008_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m786835.png',
      'p446008_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m786921.png',
      'p446008_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m786860.png'
    ],
    casemiro: [
      'p61256_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m790894.png',
      'p61256_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m790971.png',
      'p61256_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m790932.png',
      'p61256_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m786830.png',
      'p61256_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m786918.png',
      'p61256_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m786867.png'
    ],
    'lisandro-martinez': [
      'p221820_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m790890.png',
      'p221820_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m790968.png',
      'p221820_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m790926.png',
      'p221820_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m786831.png',
      'p221820_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m786929.png',
      'p221820_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m786864.png'
    ],
    'manuel-ugarte': [
      'p232112_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m790908.png',
      'p232112_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m790986.png',
      'p232112_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m790930.png',
      'p232112_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m786826.png',
      'p232112_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m786917.png',
      'p232112_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m786873.png'
    ],
    'matheus-cunha': [
      'p430871_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m790893.png',
      'p430871_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m790989.png',
      'p430871_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m790915.png',
      'p430871_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m786820.png',
      'p430871_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m786922.png',
      'p430871_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m786861.png'
    ]
  },
  newcastle: {
    'anthony-gordon': [
      'p232826_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m785036.png',
      'p232826_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m785115.png',
      'p232826_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m785069.png',
      'p232826_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m788335.png',
      'p232826_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m788414.png',
      'p232826_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m788362.png'
    ],
    'bruno-guimaraes': [
      'p208706_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m785014.png',
      'p208706_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m785131.png',
      'p208706_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m785063.png',
      'p208706_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m788342.png',
      'p208706_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m788419.png',
      'p208706_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m788361.png'
    ],
    joelinton: [
      'p180974_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m785013.png',
      'p180974_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m785117.png',
      'p180974_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m785043.png',
      'p180974_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m788336.png',
      'p180974_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m788421.png',
      'p180974_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m788382.png'
    ],
    'nick-woltemade': [
      'p470313_-_Graphics__Player_Assets__AWAY_Celebration_Custom_Image_m790600.png',
      'p470313_-_Graphics__Player_Assets__AWAY_Personality_Custom_Image_m790599.png',
      'p470313_-_Graphics__Player_Assets__AWAY_Torso_Custom_Image_m790598.png',
      'p470313_-_Graphics__Player_Assets__HOME_Celebration_Custom_Image_m790605.png',
      'p470313_-_Graphics__Player_Assets__HOME_Personality_Custom_Image_m790601.png',
      'p470313_-_Graphics__Player_Assets__HOME_Torso_Custom_Image_m790602.png'
    ],
    'sandro-tonali': [
      'p432422_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m785031.png',
      'p432422_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m785124.png',
      'p432422_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m785060.png',
      'p432422_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m788347.png',
      'p432422_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m788438.png',
      'p432422_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m788356.png'
    ]
  },
  'nottingham-forest': {
    'chris-wood': [
      'Nottingham_-_Wood.png',
      'p60689_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781761.png',
      'p60689_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781813.png',
      'p60689_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781765.png',
      'p60689_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m782267.png',
      'p60689_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m782350.png'
    ],
    'igor-jesus': [
      'Nottingham_-_Igor_Jesus.png',
      'p482973_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781759.png',
      'p482973_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781812.png',
      'p482973_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781771.png',
      'p482973_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m782268.png',
      'p482973_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m782355.png'
    ],
    'morgan-gibbs-white': [
      'p222531_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787499.png',
      'p222531_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787502.png',
      'p222531_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787500.png',
      'p222531_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m787504.png',
      'p222531_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m787507.png',
      'p222531_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m787505.png'
    ],
    murillo: [
      'Nottingham_-_Murillo.png',
      'p575476_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781762.png',
      'p575476_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781819.png',
      'p575476_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781778.png',
      'p575476_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m782272.png',
      'p575476_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m782360.png'
    ],
    'nicolas-dominguez': [
      'Nottingham_-_N._Dominguez.png',
      'p250199_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m781750.png',
      'p250199_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m781829.png',
      'p250199_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m781780.png',
      'p250199_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m782282.png',
      'p250199_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m782347.png'
    ]
  },
  sunderland: {
    'brian-brobbey': [
      'p441264_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m791593.png',
      'p441264_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m791592.png'
    ],
    'granit-xhaka': [
      'Sunderland_-_Xhaka.png',
      'p84450_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m784177.png',
      'p84450_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m784259.png',
      'p84450_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m784209.png',
      'p84450_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m780030.png',
      'p84450_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m780145.png'
    ],
    'omar-alderete': [
      'p201895_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787484.png',
      'p201895_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787491.png',
      'p201895_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787486.png',
      'p201895_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m787492.png',
      'p201895_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m787496.png',
      'p201895_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m787495.png'
    ]
  },
  tottenham: {
    'cuti-romero': [
      'p221632_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788496.png',
      'p221632_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788553.png',
      'p221632_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788515.png',
      'p221632_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m784574.png',
      'p221632_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m784651.png',
      'p221632_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m784595.png'
    ],
    'dominic-solanke': [
      'p154566_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788476.png',
      'p154566_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788563.png',
      'p154566_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788520.png',
      'p154566_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m784607.png',
      'p154566_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m784662.png',
      'p154566_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m784600.png'
    ],
    'joao-palinha': [
      'p154296_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788497.png',
      'p154296_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788557.png',
      'p154296_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788511.png',
      'p154296_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m784587.png',
      'p154296_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m784674.png',
      'p154296_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m784596.png'
    ],
    richarlison: [
      'p212319_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788481.png',
      'p212319_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788573.png',
      'p212319_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788521.png',
      'p212319_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m784575.png',
      'p212319_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m784657.png',
      'p212319_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m784589.png'
    ],
    'rodrigo-bentancur': [
      'p202993_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m788488.png',
      'p202993_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m788567.png',
      'p202993_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m788517.png',
      'p202993_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m784581.png',
      'p202993_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m784663.png',
      'p202993_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m784602.png'
    ],
    'xavi-simons': [
      'p493362_-_Graphics__Player_Assets__AWAY_Celebration_Custom_Image_m790536.png',
      'p493362_-_Graphics__Player_Assets__AWAY_Full_Length_Custom_Image_m790532.png',
      'p493362_-_Graphics__Player_Assets__AWAY_Personality_Custom_Image_m790538.png',
      'p493362_-_Graphics__Player_Assets__AWAY_Torso_Custom_Image_m790534.png',
      'p493362_-_Graphics__Player_Assets__HOME_Celebration_Custom_Image_m790535.png',
      'p493362_-_Graphics__Player_Assets__HOME_Personality_Custom_Image_m790537.png',
      'p493362_-_Graphics__Player_Assets__HOME_Torso_Custom_Image_m790531.png'
    ]
  },
  wolverhampton: {
    'jhon-arias': [
      'p230376_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787740.png',
      'p230376_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787825.png',
      'p230376_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787732.png',
      'p230376_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781614.png',
      'p230376_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781701.png',
      'p230376_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781640.png'
    ],
    'joao-gomes': [
      'p448089_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787749.png',
      'p448089_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787788.png',
      'p448089_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787770.png',
      'p448089_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781632.png',
      'p448089_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781700.png',
      'p448089_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781650.png'
    ],
    'jorgen-strand-larsen': [
      'p247412_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787728.png',
      'p247412_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787805.png',
      'p247412_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787753.png',
      'p247412_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781629.png',
      'p247412_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781709.png',
      'p247412_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781655.png'
    ],
    'santiago-bueno': [
      'p231480_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787726.png',
      'p231480_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787800.png',
      'p231480_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787771.png',
      'p231480_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781611.png',
      'p231480_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781695.png',
      'p231480_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781654.png'
    ],
    'yerson-mosquera': [
      'p501837_-_Graphics__Player_Assets__AWAY_Celebration_All_Originals_m787744.png',
      'p501837_-_Graphics__Player_Assets__AWAY_Personality_All_Originals_m787787.png',
      'p501837_-_Graphics__Player_Assets__AWAY_Torso_All_Originals_m787767.png',
      'p501837_-_Graphics__Player_Assets__HOME_Celebration_All_Originals_m781616.png',
      'p501837_-_Graphics__Player_Assets__HOME_Personality_All_Originals_m781693.png',
      'p501837_-_Graphics__Player_Assets__HOME_Torso_All_Originals_m781636.png'
    ]
  }
};
